import { apiClient } from "helpers/api_helper";


export const getAllCustomerLedgerData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Ledger/GetGroupedCustomerLedgerDetails`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getCustomerRefundableAmountDetail = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Ledger/GetCustomerRefundableAmountDetail?customerId=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const refundCustomerLedgerBalance = async (data: object) => {
    try {
        const response = await apiClient.post(`/api/v1/Ledger/RefundCustomerLedgerBalance`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

// export const createGoldMakingCharges = async (data: object) => {
//     try {
//         const response = await apiClient.post('/api/v1/MakingCharges/InsertGoldMakingCharges', data);
//         return response;
//     } catch (error: any) {
//         throw new Error(error.message);
//     }
// };